import React, { useState, useEffect, useRef } from "react";
import NavigationButtons from "../../../Common/CommonButtons/NavigationButtons";
import ActionButtonGroup from "../../../Common/CommonButtons/ActionButtonGroup";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./TransferAdjustments.css";
import AccountMasterHelp from "../../../Helper/AccountMasterHelp";
import CompanyMasterHelp from "../../../Helper/CompanyMasterHelper";
import GSTRateMasterHelp from "../../../Helper/GSTRateMasterHelp";
import UserAuditInfo from "../../../Common/UserAuditInfo/UserAuditInfo";
import { TextField, Grid, Box, Card, CardContent } from '@mui/material';
import Swal from "sweetalert2";
import SaveUpdateSpinner from "../../../Common/Spinners/SaveUpdateSpinner";

const API_URL = process.env.REACT_APP_API;

//Labels Global variables
var ToName = "";
var ToCode = "";
var FromName = "";
var FromCode = "";
var GStrateCode = "";
var GStrateName = "";
var selectedfilter = "";
var CompanyName = "";
var CompanyCode = "";
// var CrossCompanyName = "";
// var CrossCompanyCode = "";
var CrossFromName = "";
var CrossFromCode = "";
var CrossToName = "";
var CrossToCode = "";

const TransferAdjustment = () => {
  const location = useLocation();
  selectedfilter = location.state?.selectedfilter;
  const inputRef = useRef(null);

  const Year_Code = sessionStorage.getItem("Year_Code");
  const company_code = sessionStorage.getItem("Company_Code");
  const searchParams = new URLSearchParams(location.search);
  const navigatedRecord = searchParams.get('navigatedRecord');

  const [updateButtonClicked, setUpdateButtonClicked] = useState(false);
  const [saveButtonClicked, setSaveButtonClicked] = useState(false);
  const [addOneButtonEnabled, setAddOneButtonEnabled] = useState(false);
  const [saveButtonEnabled, setSaveButtonEnabled] = useState(true);
  const [cancelButtonEnabled, setCancelButtonEnabled] = useState(true);
  const [editButtonEnabled, setEditButtonEnabled] = useState(false);
  const [deleteButtonEnabled, setDeleteButtonEnabled] = useState(false);
  const [backButtonEnabled, setBackButtonEnabled] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [highlightedButton, setHighlightedButton] = useState(null);
  const [cancelButtonClicked, setCancelButtonClicked] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [SystemType, setSystemType] = useState(selectedfilter);
  const [toAccount, setToAccount] = useState("");
  const [fromAccount, setFromAccount] = useState("");
  const [crosstoaccount, setCrossToAccount] = useState("");
  const [crossfromaccount, setCrossFromAccount] = useState("");
  const [gstRateCode, setgstRateCode] = useState("");
  const [isHandleChange, setIsHandleChange] = useState(false);
  const [companycode, setCompanyCode] = useState("");
  const [companycodename, setCompanyCodeName] = useState("");
  const [crosscompanycode, setCrossCompanyCode] = useState("");
  const [crosscompanyname, setCrossCompanyName] = useState("");
  const companyCode = sessionStorage.getItem("Company_Code");
  const username = sessionStorage.getItem("username");
  const [accountCode, setAccountCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [resetKey, setResetKey] = useState(0);
  const [crossResetKey, setCrossResetKey] = useState(0);

  const selectedRecord = location.state?.selectedRecord;
  const permissions = location.state?.permissionsData;

  const initialFormData = {
    Company_Code: "",
    CrossCompanyCode: "",
    CrossFrom_acc: "",
    CrossTo_acc: "",
    From_accid: "",
    To_accid: "",
    Modified_By: "",
    Created_By: "",
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (isHandleChange) {
      handleCancel();
      setIsHandleChange(false);
    }
    // document.getElementById("System_Name_E").focus();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "System_Type") {
      setSystemType(value);
      setIsHandleChange(true);
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };


  const fetchLastRecordSystemCode = () => {
    fetch(
      `${API_URL}/get-TransferAdjusment-lastRecordNavigation?Id=${formData.Id}`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch last record");
        }
        return response.json();
      })
      .then((data) => {
        const last = data?.last_TransferAdjusment_data;

        // If we have a valid System_Code, increment it, otherwise start from 1
        const nextCode =
          last && last.Id != null && !isNaN(Number(last.Id))
            ? Number(last.Id) + 1
            : 1;

        setFormData((prevState) => ({
          ...prevState,
          Id: nextCode,
        }));
      })
      .catch((error) => {
        console.error("Error fetching last record:", error);
        // On error you can also choose to default to 1 if you want:
        setFormData((prevState) => ({
          ...prevState,
          Id: 1,
        }));
      });
  };





  const handleAddOne = () => {
    setAddOneButtonEnabled(false);
    setSaveButtonEnabled(true);
    setCancelButtonEnabled(true);
    setEditButtonEnabled(false);
    setDeleteButtonEnabled(false);
    setIsEditing(true);

    fetchLastRecordSystemCode();

    ToName = "";
    ToCode = "";
    FromName = "";
    FromCode = "";
    GStrateCode = "";
    GStrateName = "";
    selectedfilter = "";
    CompanyName = "";
    CompanyCode = "";

    CrossFromName = "";
    CrossFromCode = "";
    CrossToName = "";
    CrossToCode = "";


    resetAccountFields();

    setCrossCompanyCode("");
    setCrossCompanyName("");
    setCompanyCodeName("");
    setCompanyCode("");

    setFormData((prev) => ({
      ...prev,
      CrossCompanyCode: "",
      Company_Code: "",
      CrossTo_acc: "",
      CrossFrom_acc: "",
      To_accid: "",
      From_accid: "",
    }));

    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };


  const handleSaveOrUpdate = async () => {


    if (
      formData.Company_Code &&
      formData.CrossCompanyCode &&
      formData.Company_Code === formData.CrossCompanyCode
    ) {
      Swal.fire({
        title: "Validation Error!",
        text: "Company Code and Cross Company Code cannot be the same.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return; // ✅ Stop execution
    }

    setIsLoading(true);
    try {
      const response = await axios.post(
        `${API_URL}/create-or-update-TransferAdjusment`,
        { ...formData }
      );

      const savedId = response.data.record?.Id;

      Swal.fire({
        title: "Success!",
        text: response.data.message,
        icon: "success",
        confirmButtonText: "OK"
      });

      setIsEditMode(false);
      setAddOneButtonEnabled(true);
      setEditButtonEnabled(true);
      setDeleteButtonEnabled(true);
      setSaveButtonEnabled(false);
      setCancelButtonEnabled(false);
      setIsEditing(false);
      setUpdateButtonClicked(true);

      navigate(`/TransferAdj?navigatedRecord=${savedId}`);

    } catch (error) {

      if (error.response?.status === 409) {
        Swal.fire({
          title: "Duplicate Record!",
          text: error.response.data.details,
          icon: "warning",
          confirmButtonText: "OK"
        });
      } else if (error.response?.status === 422) {

        Swal.fire({
          title: "Invalid Account!",
          text: error.response.data.details,
          icon: "error",
          confirmButtonText: "OK"
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "Failed to save record. Please try again.",
          icon: "error",
          confirmButtonText: "OK"
        });
      }
      console.error("Error saving data:", error.response?.data || error.message);
    }
    finally {
      setIsLoading(false);
    }
  };


  const handleEdit = () => {
    setIsEditMode(true);
    setAddOneButtonEnabled(false);
    setSaveButtonEnabled(true);
    setCancelButtonEnabled(true);
    setEditButtonEnabled(false);
    setDeleteButtonEnabled(false);
    setBackButtonEnabled(true);
    setIsEditing(true);
  };

  const handleCancel = () => {
    axios
      .get(
        `${API_URL}/get-TransferAdjusment-lastRecord?Id=${formData.Id}`
      )
      .then((response) => {
        const data = response.data;
        if (data && data.last_TransferAdjusment_data) {
          ToName = data.label_names[0].ToACName;
          ToCode = data.last_TransferAdjusment_data.To_accid;
          FromName = data.label_names[0].FromACName;
          FromCode = data.last_TransferAdjusment_data.From_accid;
          CrossToName = data.label_names[0].CrossToACName;
          CrossToCode = data.last_TransferAdjusment_data.CrossTo_acc;
          CrossFromName = data.label_names[0].CrossFromAcc;
          CrossFromCode = data.last_TransferAdjusment_data.CrossFrom_acc;
          CompanyName = data.label_names[0].Company_Name_E;
          setCompanyCode(data.last_TransferAdjusment_data.Company_Code || "");
          setCompanyCodeName(data.label_names[0].Company_Name_E || "");
          setCrossCompanyName(data.label_names[0].CrossCompanyName || "");
          setCrossCompanyCode(data.last_TransferAdjusment_data.CrossCompanyCode || "");
          GStrateName = data.label_names[0].GST_Name;
          GStrateCode = data.last_TransferAdjusment_data.Gst_Code;
          setFormData({
            ...formData,
            ...data.last_TransferAdjusment_data,
          });
        } else {
          console.error("No data found for the specified SystemType");
        }
      })
      .catch((error) => {
        console.error("Error fetching latest data for edit:", error);
      });
    setIsEditing(false);
    setIsEditMode(false);
    setAddOneButtonEnabled(true);
    setEditButtonEnabled(true);
    setDeleteButtonEnabled(true);
    setBackButtonEnabled(true);
    setSaveButtonEnabled(false);
    setCancelButtonEnabled(false);
    setCancelButtonClicked(true);
  };

  const handleDelete = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `You want to delete Id: ${formData.Id}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      cancelButtonText: "Cancel",
      confirmButtonText: "Yes, Delete",
      reverseButtons: true,
      focusCancel: true,
    });

    if (result.isConfirmed) {
      // Update UI state
      setIsEditMode(false);
      setAddOneButtonEnabled(true);
      setEditButtonEnabled(true);
      setDeleteButtonEnabled(true);
      setBackButtonEnabled(true);
      setSaveButtonEnabled(false);
      setCancelButtonEnabled(false);
      setIsLoading(true);

      try {
        const deleteApiUrl = `${API_URL}/delete-TransferAdjusment?Id=${formData.Id}`;
        const response = await axios.delete(deleteApiUrl);

        Swal.fire({
          title: "Deleted!",
          text: "Record deleted successfully!",
          icon: "success",
          confirmButtonText: "OK",
        });

        handleCancel();
      } catch (error) {
        toast.error("Something went wrong!");
        console.error("Error during API call:", error);
      }
      finally {
        setIsLoading(false);
      }
    } else {
      Swal.fire({
        title: "Cancelled",
        text: "Your record is safe 🙂",
        icon: "info",
      });
    }
  };

  const handleBack = () => {
    navigate("/TransferAdjutility");
  };
  const fetchSystemMasterData = async (url, dataKey) => {
    try {
      const response = await fetch(url);
      if (response.ok) {
        const data = await response.json();
        const systemData = data[dataKey];

        ToName = data.label_names[0].ToACName;
        ToCode = systemData.To_accid;
        FromName = data.label_names[0].FromACName;
        FromCode = systemData.From_accid;
        CrossToName = data.label_names[0].CrossToACName;
        CrossToCode = systemData.CrossTo_acc;
        CrossFromName = data.label_names[0].CrossFromAcc;
        CrossFromCode = systemData.CrossFrom_acc;
        // CompanyName = data.label_names[0].Company_Name_E;
        // CompanyCode = systemData.Company_Code;
        setCompanyCode(systemData.Company_Code || "");
        setCompanyCodeName(data.label_names[0].Company_Name_E || "");
        setCrossCompanyName(data.label_names[0].CrossCompanyName || "");
        setCrossCompanyCode(systemData.CrossCompanyCode || "");
        GStrateName = data.label_names[0].GST_Name;
        GStrateCode = systemData.Gst_Code;

        setFormData((prev) => ({
          ...prev,
          ...systemData,
        }));
      } else {
        console.error(
          "Failed to fetch data:",
          response.status,
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  useEffect(() => {
    if (selectedRecord) {
      handlerecordDoubleClicked();
    }
    else if (navigatedRecord && !isNaN(navigatedRecord) && parseInt(navigatedRecord) > 0) {
      fetchSystemMasterData();
    }
    else {
      handleAddOne();
    }
  }, [selectedRecord, navigatedRecord]);

  const handleFirstButtonClick = async () => {
    const url = `${API_URL}/get-first-TransferAdjusment`;
    await fetchSystemMasterData(url, "first_TransferAdjusment_data");
  };

  const handlePreviousButtonClick = async () => {
    const url = `${API_URL}/get-previous-TransferAdjusment?Id=${formData.Id}`;
    await fetchSystemMasterData(url, "previous_TransferAdjusment_data");
  };

  const handleNextButtonClick = async () => {
    const url = `${API_URL}/get-next-TransferAdjusment?Id=${formData.Id}`;
    await fetchSystemMasterData(url, "next_TransferAdjusment_data");
  };

  const handleLastButtonClick = async () => {
    const url = `${API_URL}/get-TransferAdjusment-lastRecordNavigation?Id=${formData.Id}`;
    await fetchSystemMasterData(url, "last_TransferAdjusment_data");
  };

  const handlerecordDoubleClicked = async () => {
    const url = `${API_URL}/get-TransferAdjusment-SelectedRecord?Id=${selectedRecord.Id}`;
    await fetchSystemMasterData(url, "Selected_TransferAdjusment_data");

    setIsEditing(false);
    setIsEditMode(false);
    setAddOneButtonEnabled(true);
    setEditButtonEnabled(true);
    setDeleteButtonEnabled(true);
    setBackButtonEnabled(true);
    setSaveButtonEnabled(false);
    setCancelButtonEnabled(false);
    setUpdateButtonClicked(true);
  };

  const handleKeyDown = async (event) => {
    if (event.key === "Tab") {
      const changeNoValue = event.target.value;
      const url = `${API_URL}/get-TransferAdjusment-SelectedRecord?Id=${changeNoValue}`;
      await fetchSystemMasterData(url, "Selected_TransferAdjusment_data");
      setIsEditing(false);
    }
  };

  const resetAccountFields = () => {
    // Global variables
    ToName = "";
    ToCode = "";

    FromName = "";
    FromCode = "";

    CrossToName = "";
    CrossToCode = "";

    CrossFromName = "";
    CrossFromCode = "";

    // Local states
    setToAccount("");
    setFromAccount("");
    setCrossToAccount("");
    setCrossFromAccount("");

    // Clear formData values
    setFormData((prev) => ({
      ...prev,
      To_accid: "",
      From_accid: "",
      CrossTo_acc: "",
      CrossFrom_acc: "",
    }));
  };



  const handleCompanyCode = (code, name) => {
    setCompanyCode(code);
    setCompanyCodeName(name);

    ToName = ""; ToCode = "";
    FromName = ""; FromCode = "";
    CrossToName = ""; CrossToCode = "";
    CrossFromName = ""; CrossFromCode = "";

    setCrossCompanyCode("");
    setCrossCompanyName("");
    setCompanyCode("");
    setCompanyCodeName("");
    setToAccount("");
    setFromAccount("");
    setCrossToAccount("");
    setCrossFromAccount("");

    setResetKey(prev => prev + 1);       // resets TO, FROM
    setCrossResetKey(prev => prev + 1);  // resets Cross Company, CrossTO, CrossFROM

    setFormData((prev) => ({
      ...prev,
      Company_Code: code || "",
      CrossCompanyCode: "",
      To_accid: "",
      From_accid: "",
      CrossTo_acc: "",
      CrossFrom_acc: "",
    }));
  };

  const handleCrossCompanyCode = (code, name) => {

    if (code && formData.Company_Code && code === formData.Company_Code) {
      Swal.fire({
        title: "Validation Error!",
        text: "Cross Company Code cannot be the same as Company Code.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return; // ✅ Don't set the value
    }
    setCrossCompanyCode(code || "");
    setCrossCompanyName(name || "");

    CrossToName = ""; CrossToCode = "";
    CrossFromName = ""; CrossFromCode = "";

    setCrossToAccount("");
    setCrossFromAccount("");

    setCrossResetKey(prev => prev + 1);  // 👈 only resets cross fields

    setFormData((prev) => ({
      ...prev,
      CrossCompanyCode: code || "",
      CrossTo_acc: "",
      CrossFrom_acc: "",
    }));
  };


  const handleGstRateCode = (code) => {
    setgstRateCode(code);
    setFormData({
      ...formData,
      Gst_Code: code,
    });
  };

  const handleAccountCodeChange = (key, code) => {
    setAccountCode(code);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [key]: code,
    }));
  };

  //Handle individual function to manage the account master
  const handleToAccount = (code) =>
    handleAccountCodeChange("To_accid", code);
  const handleFromAccount = (code) =>
    handleAccountCodeChange("From_accid", code);
  const handlCrossToAccount = (code) =>
    handleAccountCodeChange("CrossTo_acc", code);
  const handlCrossFromAccount = (code) =>
    handleAccountCodeChange("CrossFrom_acc", code);

  return (
    <>
      {isLoading && (
        <div className="loading-overlay">
          <div className="spinner-container">
            <SaveUpdateSpinner />
          </div>
        </div>
      )}
      <UserAuditInfo
        createdBy={formData.Created_By}
        modifiedBy={formData.Modified_By}
        title={"Transfer AdjustMent"}
      />
      <div style={{ marginTop: "30px" }}>
        <ToastContainer autoClose={500} />
        <ActionButtonGroup
          handleAddOne={handleAddOne}
          addOneButtonEnabled={addOneButtonEnabled}
          handleSaveOrUpdate={handleSaveOrUpdate}
          saveButtonEnabled={saveButtonEnabled}
          isEditMode={isEditMode}
          handleEdit={handleEdit}
          editButtonEnabled={editButtonEnabled}
          handleDelete={handleDelete}
          deleteButtonEnabled={deleteButtonEnabled}
          handleCancel={handleCancel}
          cancelButtonEnabled={cancelButtonEnabled}
          handleBack={handleBack}
          backButtonEnabled={backButtonEnabled}
          permissions={permissions}
        />
        <div>
          <NavigationButtons
            handleFirstButtonClick={handleFirstButtonClick}
            handlePreviousButtonClick={handlePreviousButtonClick}
            handleNextButtonClick={handleNextButtonClick}
            handleLastButtonClick={handleLastButtonClick}
            highlightedButton={highlightedButton}
            isEditing={isEditing}
            isFirstRecord={formData.Company_Code === 1}
          />
        </div>
      </div>

      <div>
        <form>
          <div className="bg-white rounded-lg shadow-md p-6 max-w-4xl mx-auto">
            <div className="flex flex-col space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
                <div className="col-span-1">
                  <label htmlFor="changeNo" className="block text-left text-sm font-bold text-gray-800  flex items-center">Change No</label>
                  <input
                    type="text"
                    id="changeNo"
                    name="changeNo"
                    autoComplete="off"
                    onKeyDown={handleKeyDown}
                    disabled={!addOneButtonEnabled}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  />
                </div>



                <div className="col-span-2">
                  <label htmlFor="group_Code" className="block text-left text-sm font-bold text-gray-800 flex items-center">
                    ID
                    <span className="ml-1 text-xs text-gray-500">(Auto-generated)</span>
                  </label>
                  <div className="relative group">
                    <input
                      type="text"
                      id="Id"
                      name="Id"
                      value={formData.Id}
                      onChange={handleChange}
                      disabled
                      className="w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm sm:text-sm"
                    />
                    <div className="absolute right-3 top-2.5 text-gray-400">
                      <svg
                        className="h-5 w-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="absolute left-0 -top-6 hidden group-hover:block bg-gray-800 text-white text-xs px-2 py-1 rounded whitespace-nowrap">
                      Auto-generated and read-only
                    </div>
                  </div>
                </div>
              </div>



              <div className="md:col-span-2">
                <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                  <label
                    htmlFor="Company_Code"
                    className="block text-left text-sm font-bold text-gray-800 text-base"
                  >
                    Company Code:
                  </label>
                  <div className="flex-grow ml-9">
                    <CompanyMasterHelp
                      onAcCodeClick={handleCompanyCode}
                      CompanyName={companycodename}
                      CompanyCode={formData.Company_Code}
                      name="Company_Code"
                      Ac_type={[]}
                      disabledFeild={!isEditing || isEditMode}
                    />
                  </div>
                </div>
              </div>


              <div className="md:col-span-2" >
                <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                  <label
                    htmlFor="To_accid"
                    className="block text-left text-sm font-bold text-gray-800 text-base"
                  >
                    Company Name:
                  </label>
                  <div className="flex-grow ml-10">
                    <AccountMasterHelp
                      key={`to-${resetKey}`}
                      onAcCodeClick={handleToAccount}
                      CategoryName={ToName}
                      CategoryCode={ToCode}
                      name="To_accid"
                      Ac_type={[]}
                      Company_Code={formData.Company_Code}
                      disabledFeild={!isEditing || isEditMode}
                    />
                  </div>
                </div>
              </div>

              <div className="md:col-span-2">
                <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                  <label
                    htmlFor="From_accid"
                    className="block text-left text-sm font-bold text-gray-800 text-base"
                  >
                    Company Bank:
                  </label>
                  <div className="flex-grow ml-12">
                    <AccountMasterHelp
                      key={`to-${resetKey}`}
                      onAcCodeClick={handleFromAccount}
                      CategoryName={FromName}
                      CategoryCode={FromCode}
                      name="From_accid"
                      Ac_type={[]}
                      Company_Code={formData.Company_Code}
                      disabledFeild={!isEditing || isEditMode}
                    />
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                <label
                  htmlFor="CrossCompanyCode"
                  className="block text-left text-sm font-bold text-gray-800 text-base"
                >
                  Cross Company Code:
                </label>
                <div className="flex-grow ">
                  <CompanyMasterHelp
                    key={`crossco-${crossResetKey}`}
                    onAcCodeClick={handleCrossCompanyCode}
                    CompanyName={crosscompanyname}
                    CompanyCode={formData.CrossCompanyCode}
                    name="CrossCompanyCode"
                    Ac_type={[]}
                    disabledFeild={!isEditing || isEditMode}
                  />
                </div>
              </div>

              <div className="md:col-span-2">
                <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                  <label
                    htmlFor="CrossTo_Acc"
                    className="block text-left text-sm font-bold text-gray-800 text-base"
                  >
                    CROSS TO Bank Name:
                  </label>
                  <div className="flex-grow ml-14">
                    <AccountMasterHelp
                      key={`crossco-${crossResetKey}`}
                      onAcCodeClick={handlCrossToAccount}
                      CategoryName={CrossToName}
                      CategoryCode={CrossToCode}
                      name="CrossTo_Acc"
                      Ac_type={[]}
                      Company_Code={formData.CrossCompanyCode}
                      disabledFeild={!isEditing || isEditMode}
                    />
                  </div>
                </div>
              </div>

              <div className="md:col-span-2">
                <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                  <label
                    htmlFor="Item_Select"
                    className="block text-left text-sm font-bold text-gray-800 text-base"
                  >
                    CROSS FROM Company Name:
                  </label>
                  <div className="flex-grow ml-1">
                    <AccountMasterHelp
                      key={`crossco-${crossResetKey}`}
                      onAcCodeClick={handlCrossFromAccount}
                      CategoryName={CrossFromName}
                      CategoryCode={CrossFromCode}
                      name="CrossFrom_acc"
                      Ac_type={[]}
                      Company_Code={formData.CrossCompanyCode}
                      disabledFeild={!isEditing || isEditMode}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};
export default TransferAdjustment;

